<template>
    <div class="pb-0 card-header text-start text-center">
        <img class="logoImg" :src="companyLogo" alt="Company Logo" />
    </div>
</template>

<script>
export default {
    name: "CompanyLogo",
    data() {
        return {
            companyLogo: null
        };
    },
    mounted() {
        this.setCompanyLogo();
    },
    methods: {
        setCompanyLogo() {
        const hostname = window.location.hostname.toLowerCase();

        const logoMap = {
            salfa: require("@/assets/img/logos/salfa/logo-salfa.svg"),
            econorent: require("@/assets/img/logos/econorent/logo-econorent.svg"),
            mitta: require("@/assets/img/logos/mitta/logo-mitta.svg")
        };

        // Buscar si el hostname contiene el nombre de alguno de los clientes
        const clientKey = Object.keys(logoMap).find(client =>
            hostname.includes(client)
        );

        // Si lo encuentra, usa su logo; si no, usa uno genérico
        this.companyLogo = logoMap[clientKey] || require("@/assets/img/logos/migps/logo-migps.svg");
        }
    }
};
</script>

<style scoped>
    .logoImg {
        width: 80%;
        max-width: 260px;
    }
</style>